export const REWARDS_COLLECTION_STRINGS = {
  buttonBadgesList: 'Go to  Your Badges list',
};
